import "./dashboard-kitchenOS.css";
import { PresentationChartBarIcon, ExclamationTriangleIcon, ClockIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { MOCK_STAT_VALUES, MOCK_PREP_REQUESTS, MOCK_INVENTORY_ALERTS } from "../MOCK_DATA_KOS";

// ─── Static Config ────────────────────────────────────────────────────────────

const STAT_CARD_CONFIG = [
  { label: "Active Orders",   icon: PresentationChartBarIcon, iconColor: "#f59e0b", iconBg: "#fef3c7", metaLabel: "vs last hour"    },
  { label: "Low Stock Items", icon: ExclamationTriangleIcon,  iconColor: "#e90000", iconBg: "#fee2e2", metaLabel: "new alerts"       },
  { label: "Prep Efficiency", icon: ClockIcon,                iconColor: "#219647", iconBg: "#dcfce7", metaLabel: "avg prep time"    },
  { label: "Tasks Completed", icon: CheckCircleIcon,          iconColor: "#0860e6", iconBg: "#dbeafe", metaLabel: "of daily target"  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

function getUrgencyClass(urgency) {
  if (urgency === "ASAP") return "d_kos_urgency-asap";
  if (urgency === "Within 2h") return "d_kos_urgency-soon";
  return "d_kos_urgency-later";
}

function getAlertBarClass(percent) {
  if (percent <= 10) return "d_kos_alert-bar-critical";
  if (percent <= 20) return "d_kos_alert-bar-warning";
  return "d_kos_alert-bar-ok";
}

// ─── Component ────────────────────────────────────────────────────────────────

export default function DashboardKitchenOS() {
  return (
    <div className="d_kos_dashboard">
      {/* Header */}
      <div className="d_kos_header">
        <p className="d_kos_title">Real-Time Kitchen Analytics</p>
        <p className="d_kos_subtitle">Monitor consumption, inventory, and active prep requests.</p>
      </div>

      {/* Stat Cards */}
      <div className="d_kos_stats-row">
        {STAT_CARD_CONFIG.map((config, i) => {
          const data = MOCK_STAT_VALUES[i];
          return (
            <div key={config.label} className="d_kos_stat-card">
              <div className="d_kos_stat-card-top">
                <p className="d_kos_stat-label">{config.label}</p>
                <div className="d_kos_stat-icon-wrap" style={{ background: config.iconBg }}>
                  <config.icon className="d_kos_stat-icon" style={{ color: config.iconColor }} />
                </div>
              </div>
              <p className={`d_kos_stat-value ${data?.highlight ? "d_kos_stat-alert" : ""}`}>
                {data?.value}
              </p>
              {data?.progress !== undefined ? (
                <div className="d_kos_stat-progress-wrap">
                  <div className="d_kos_stat-progress-bar" style={{ width: `${data.progress}%` }} />
                </div>
              ) : null}
              <p className="d_kos_stat-meta">{data?.metaValue} {config.metaLabel}</p>
            </div>
          );
        })}
      </div>

      {/* Main Section */}
      <div className="d_kos_main-section">
        {/* Auto-Prep Requests */}
        <div className="d_kos_prep-panel">
          <div className="d_kos_panel-header">
            <div>
              <p className="d_kos_panel-title">Auto-Prep Requests</p>
              <p className="d_kos_panel-subtitle">Generated based on current stock and forecast</p>
            </div>
            <span className="d_kos_ai-badge">AI Triggered</span>
          </div>

          <div className="d_kos_prep-list">
            {MOCK_PREP_REQUESTS?.map((item) => (
              <div key={item?.id} className="d_kos_prep-item">
                <div className={`d_kos_prep-accent ${getUrgencyClass(item?.urgency)}`} />
                <div className="d_kos_prep-info">
                  <p className="d_kos_prep-name">{item?.name}</p>
                  <p className="d_kos_prep-meta">
                    Current: {item.current} &bull; Target: {item?.target}
                  </p>
                </div>
                <span className="d_kos_prep-urgency">{item.urgency}</span>
                <button className="d_kos_prep-btn">Start Prep</button>
              </div>
            ))}
          </div>
        </div>

        {/* Low Inventory Alerts */}
        <div className="d_kos_alert-panel">
          <p className="d_kos_panel-title">Low Inventory Alerts</p>

          <div className="d_kos_alert-list">
            {MOCK_INVENTORY_ALERTS?.map((item) => (
              <div key={item?.id} className="d_kos_alert-item">
                <div className="d_kos_alert-row">
                  <p className="d_kos_alert-name">{item?.name}</p>
                  <p className={`d_kos_alert-percent ${item?.percent <= 10 ? "d_kos_alert-critical" : ""}`}>
                    {item?.percent}%
                  </p>
                </div>
                <div className="d_kos_alert-bar-bg">
                  <div
                    className={`d_kos_alert-bar-fill ${getAlertBarClass(item?.percent)}`}
                    style={{ width: `${item?.percent}%` }}
                  />
                </div>
              </div>
            ))}
          </div>

          <button className="d_kos_view-all-btn">View All Inventory</button>
        </div>
      </div>
    </div>
  );
}